import { useState } from "react";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";

const GUEST_COUNT_RANGES = [
  {
    value: "50",
    label: "ca. 50 Gäste",
  },
  {
    value: "75",
    label: "ca. 75 Gäste",
  },
  { value: "100", label: "ca. 100 Gäste" },
  { value: "150", label: "ca. 150 Gäste" },
  { value: "200", label: "ca. 200 Gäste" },
  { value: "201", label: "mehr als 200 Gäste" },
];

export default function Step2GuestCount({ value, onNext, onBack }) {
  const [selectedValue, setSelectedValue] = useState(value || "");

  const handleSelect = (guestCount) => {
    setSelectedValue(guestCount);
  };

  const handleNext = () => {
    if (selectedValue) {
      onNext({ guestCount: selectedValue });
    }
  };

  return (
    <div className="space-y-6">
      <StepHeader
        title="Wie viele Gäste erwartest du?"
        description="Damit finden wir die passende Drucker-Kapazität für dich."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {GUEST_COUNT_RANGES.map((range) => (
          <button
            key={range.value}
            onClick={() => handleSelect(range.value)}
            className={`p-4 rounded-xl border-2 transition-all text-left ${
              selectedValue === range.value
                ? "border-[#FF5744] bg-[#FFF4F2]"
                : "border-slate-200 bg-white hover:border-slate-300"
            }`}
          >
            <div className="font-semibold text-slate-900 mb-1">
              {range.label}
            </div>
          </button>
        ))}
      </div>

      {/* Navigation */}
      <WizardNavigation
        onBack={onBack}
        onNext={handleNext}
        disableNext={!selectedValue}
      />
    </div>
  );
}
